module.exports = __webpack_public_path__ + "img/ball2_xb.66b45f4e.png";